export default __webpack_public_path__ + "static/media/Astronaut_10.abac1978.png";